const reduceName = (value) => {
  const names = value.split(' ')
  if (names.length <= 1) { return names[0] }
  return names[0] + ' ' + names[names.length - 1]
}

export default reduceName
